var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.bannerImageUrl)?_c('div',{staticClass:"pc-header-image"},[_c('img',{attrs:{"src":_vm.bannerImageUrl}})]):_vm._e(),_c('div',{staticClass:"page-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }